<template>
  <div class="SchoolCooperation">
    <PageBanner :bannerObj="bannerObj"></PageBanner>
    <div class="list_nav ">
      <div :class="['item_nav',curKey.includes(item.key) ?'cur':'']" v-for="(item,index) in list_nav" :key="index"
           @click="clickNav(item)">
        {{ item.label }}
      </div>
    </div>
    <div class="content">
      <component :is='curKey' @ToDetails="ToDetails" @ToBlack="ToBlack"></component>
    </div>

  </div>
</template>
<script>
import PageBanner from "@/components/common/pageBanner"
import PracticeBase from "@/components/SchoolCooperation/PracticeBase"
import CollaborativeEducation from "@/components/SchoolCooperation/CollaborativeEducation"
import CollaborationCase from "@/components/SchoolCooperation/CollaborationCase"
import CollaborationCaseDetails from "@/components/SchoolCooperation/CollaborationCaseDetails"

export default {
  name: "SchoolCooperation",
  components: {
    PageBanner,
    PracticeBase,
    CollaborativeEducation,
    CollaborationCase,
    CollaborationCaseDetails
  },

  metaInfo () {
    return {
      title: "校企合作-广州统计师事务所",
      meta: [
        { name: "keywords", content: "广州统计师事务所,校企合作" },
        { name: "description", content: "广州统计师事务所的校企合作" },
      ],
    }
  },
  data () {
    return {
      bannerObj: {
        lableZh: "校企合作",
        lableEn: "SCHOOL-ENTERPRISE COOPERATION",
        bannerImg: require("@/assets/img/schoolCooperation/banner.png"),
      },
      curKey: 'PracticeBase',
      list_nav: [
        {
          label: '实习基地',
          key: 'PracticeBase'
        },
        {
          label: '协同育人',
          key: 'CollaborativeEducation'
        },
        {
          label: '合作案例',
          key: 'CollaborationCase'
        },
      ]
    }
  },
  mounted () {
    // 在项目加载完成之后初始化wow
    this.$nextTick(() => {
      new this.$wow({
        //默认为true
        live: false,
      }).init()
    })
  },
  methods: {
    clickNav (data) {
      this.curKey = data.key
    },
    // 查看合作伙伴详情
    ToDetails () {
      // console.log('查看合作伙伴详情')
      this.curKey = 'CollaborationCaseDetails'
    },
    // 查看合作伙伴详情
    ToBlack () {
      this.curKey = 'CollaborationCase'
    }
  }
};
</script>
<style lang="scss" scoped>
.SchoolCooperation {
  padding: 0 0 60px 0;
  background-color: #f7f7fb;
  .list_nav {
    display: flex;
    justify-content: center;
    width: 100%;
    margin: -30px auto 0;
    position: relative;
    z-index: 2;
    .item_nav {
      cursor: pointer;
      width: 280px;
      height: 40px;
      margin: 0 10px;
      background: #ffffff;
      border: 1px solid #e5e5e5;
      text-align: center;
      font-weight: bold;
      font-size: 16px;
      color: #333333;
      line-height: 40px;
      transition: 0.4s;
      &.cur {
        background: #406cdd;
        border: 1px solid #e5e5e5;
        color: #ffffff;
      }
    }
  }
  .content {
    width: 1180px;
    padding: 40px 50px;
    margin: 20px auto 0;
    background: #ffffff;
    // border: 1px solid #e8e8e8;
  }
}
</style>
